import { Client } from '@/types'
import { User, UserRole } from '@/types/user.types'
import { isNeoPlatformRole } from '@/utils/role-access'

export function getClientResellerId(client: Pick<Client, 'reseller'>): string | undefined {
  if (!client.reseller) return undefined
  return typeof client.reseller === 'string' ? client.reseller : client.reseller._id
}

export function isAttachedClient(client: Pick<Client, 'reseller'>): boolean {
  return Boolean(getClientResellerId(client))
}

export function filterClientsForUser(
  clients: Client[] | null | undefined,
  user: Pick<User, '_id' | 'role'> | null | undefined,
  scope: 'direct' | 'attached' = 'direct'
): Client[] {
  if (!clients) return []
  if (!user || isNeoPlatformRole(user.role)) {
    return clients.filter(client =>
      scope === 'direct' ? isDirectClient(client) : isAttachedClient(client)
    )
  }
  if (user.role === UserRole.RESELLER) {
    return clients.filter(client => getClientResellerId(client) === user._id)
  }
  return clients
}

/** Admin-created client with no reseller — billed on the client's Flux fiche. */
export function isDirectClient(client: Pick<Client, 'reseller'>): boolean {
  return !getClientResellerId(client)
}
